import { Namespace } from '../translation/namespace';
import i18next from '../translation/i18n';
import ILink from '../types/ILink';
import { PagePackStates, PagePackState } from '../types/api/PagePackState';

export function getTitle({
  link,
  title,
  packState,
  hasReadRestrictions,
}: {
  link: ILink;
  title: string;
  packState: PagePackStates;
  hasReadRestrictions: boolean;
}): string {
  // add a title attribute if link name differs from title
  let linkTitle = title !== link.name ? title : '';

  if (packState === PagePackState.ONLY_DRAFT_VERSION || hasReadRestrictions) {
    linkTitle += ' (';

    if (packState === PagePackState.ONLY_DRAFT_VERSION) {
      linkTitle += `${i18next.t(`${Namespace.glossary}:draft`)}`;

      if (hasReadRestrictions) {
        linkTitle += ', ';
      }
    }

    if (hasReadRestrictions) {
      linkTitle += `${i18next.t(`${Namespace.glossary}:restricted`)}`;
    }

    linkTitle += ')';
  }

  return linkTitle;
}
